export default __webpack_public_path__ + "static/media/icons8-chrome-240.b27e2e55.png";